import React, {useEffect} from 'react';
import {Button, Card, Form, Input, message} from 'antd';
import {useInput} from 'react-hanger';
import UploadImage from '../../components/UploadImage';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {SystemApi, SystemConfig} from '../../scaffold';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function ManageSystemPage() {
  const bannerUrl01 = useInput('');
  const bannerUrl02 = useInput('');
  const bannerUrl03 = useInput('');
  const bannerImgPath01 = useInput('');
  const bannerImgPath02 = useInput('');
  const bannerImgPath03 = useInput('');
  const saveHook = useOpenApiFpRequest(SystemApi, SystemApi.prototype.systemSavePost);
  const getHook = useOpenApiFpRequest(SystemApi, SystemApi.prototype.systemGetGet);

  function get() {
    getHook
      .request({})
      .then((res: SystemConfig) => {
        bannerUrl01.setValue(res?.bannerUrl01 || '');
        bannerUrl02.setValue(res?.bannerUrl02 || '');
        bannerUrl03.setValue(res?.bannerUrl03 || '');
        bannerImgPath01.setValue(res?.bannerImgPath01 || '');
        bannerImgPath02.setValue(res?.bannerImgPath02 || '');
        bannerImgPath03.setValue(res?.bannerImgPath03 || '');
      })
      .catch(CommonApiErrorHandler);
  }
  function save() {
    saveHook
      .request({
        saveSystemConfigParams: {
          bannerUrl01: bannerUrl01.value,
          bannerUrl02: bannerUrl02.value,
          bannerUrl03: bannerUrl03.value,
          bannerImgPath01: bannerImgPath01.value,
          bannerImgPath02: bannerImgPath02.value,
          bannerImgPath03: bannerImgPath03.value,
        },
      })
      .then(() => {
        message.success('保存成功');
        get();
      })
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    get();
  }, []);

  return (
    <div className={'p-20'}>
      <Card title={'系统配置'}>
        <Form layout={'vertical'}>
          <Form.Item label={'横幅图片 01'}>
            <UploadImage {...bannerImgPath01.valueBind} />
          </Form.Item>
          <Form.Item label={'横幅跳转地址 01'}>
            <Input {...bannerUrl01.eventBind} />
          </Form.Item>
          <Form.Item label={'横幅图片 02'}>
            <UploadImage {...bannerImgPath02.valueBind} />
          </Form.Item>
          <Form.Item label={'横幅跳转地址 02'}>
            <Input {...bannerUrl02.eventBind} />
          </Form.Item>
          <Form.Item label={'横幅图片 03'}>
            <UploadImage {...bannerImgPath03.valueBind} />
          </Form.Item>
          <Form.Item label={'横幅跳转地址 03'}>
            <Input {...bannerUrl03.eventBind} />
          </Form.Item>
        </Form>
        <Button type={'primary'} loading={saveHook.loading} onClick={save}>
          保存
        </Button>
      </Card>
    </div>
  );
}
